export default __webpack_public_path__ + "static/media/@jehrodriguesmakeup.1f0b5f71.jpg";